<template>
    <div class="footer text-sm bg-indigo text-white flex flex-wrap pt-7 pr-5 pb-5 pl-40 relative xs:pl-7">
        <div class="menu w-1/6 pb-5 pl-10 relative md:w-1/4 sm:w-1/2 xxs:w-full">
            <h3 class="font-bold text-white text-base">ons centrum</h3>
            <ul>
                <!--<li><NuxtLink to="/missie-visie">missie / visie</NuxtLink></li>-->
                <li><a href="/centrumreglement" target="_blank">centrumreglement</a></li>
                
                <li><NuxtLink to="/evacuatieplannen">evacuatieplannen</NuxtLink></li>
                <li><NuxtLink to="/internationalisering">internationalisering</NuxtLink></li>
                <li><a href="/privacyverklaring" target="_blank">privacy</a> | 
                    <NuxtLink to="/cookies">cookies</NuxtLink></li>
                <li><a href="/uploads/algemeen/visie_cvovolt.pdf" target="_blank">visie</a></li>
            </ul>
        </div>
        <div class="menu w-1/6 pb-5 pl-10 relative md:w-1/4 sm:w-1/2 xxs:w-full">
            <h3 class="font-bold text-white text-base">cursisten</h3>
            <ul>
                <li><a href="https://moodle.cvovolt.be" target="_blank">leerplatform</a></li>
                <li><NuxtLink to="/lokaal">lokaal</NuxtLink></li>
                <li><a href="https://mijn.cvovolt.be" target="_blank">mijn cvo volt</a></li>
                <li><a href="/plek-olc" target="_blank">PLeK | OLC</a></li>
            </ul>
        </div>
        <div class="break narrow"></div>
        <div class="menu w-1/6 pb-5 pl-10 relative md:w-1/4 sm:w-1/2 xxs:w-full">
            <h3 class="font-bold text-white text-base">informatie</h3>
            <ul>
                <li><NuxtLink to="/contact">contact</NuxtLink></li>
                <li><NuxtLink to="/agenda">agenda</NuxtLink></li>
                <li><NuxtLink to="/nieuws/infomomenten">infomomenten</NuxtLink></li>
            </ul>
        </div>
        <div class="menu w-1/6 pb-5 pl-10 relative md:w-1/4 sm:w-1/2 xxs:w-full">
            <h3 class="font-bold text-white text-base">personeel</h3>
            <ul>
                <li><a href="https://personeel.cvovolt.be" target="_blank">personeel.cvovolt.be</a></li>
                <li><NuxtLink to="/vacatures">vacatures</NuxtLink></li>
            </ul>
        </div>
        <div class="break"></div>
        <p>
            Copyright {{year}} © cvo volt  |  Interleuvenlaan 3-5, 3001 Heverlee  | <span v-html="email"></span> <br>
            cvo volt is een instelling van <a href="https://huis11.be/" class="copyrightInfo" target="_blank">Scholengroep Huis 11</a> - Ondernemingsnummer 0267.378.817<br>
        </p>
        <div class="logos ml-auto min-w-24">
            <ul>   
                <li class="sg11"><a href="https://huis11.be/" target="_blank">Scholengroep 11</a></li>   
                <li class="go"><a href="https://www.g-o.be" target="_blank">GO!</a></li>   
            </ul>   
        </div>
    </div>
</template>

<script setup>
    const emailTools = useEmailTools();
    const year = computed(() => new Date().getFullYear());
    const email = computed(() => emailTools.obfuscateEmailAddress('info@cvovolt.be'));
</script>

<style lang="postcss">

.footer {

        &:before {
            content: "";
            position: absolute;
            top: -1px;
            bottom: 0;
            left: 0;
            width: 120px;
            background-color: #ffffff;
            transform: skew(-30deg);
            transform-origin: top;
            @media (max-width: 630px) {
                width: unset;
            }
        }
    
        & .menu {
            
            &:before {
                content: "";
                width: 20px;
                height: 2px;
                background-color: #d92a2a;
                left: 0;
                top: 8px;
                position: absolute;
            }
            &:after {
                content: "";
                height: 12px;
                width: 12px;
                border-radius: 50%;
                border: 2px solid #d92a2a;
                background-color: #ffffff;
                top: 4px;
                left: 20px;
                position: absolute;
            }
            &:hover:after {
                background-color: #d92a2a 
            }
            & h3 {
                /* margin: 0; 
                color: #ffffff; */
            }
            & a:hover {
                color: #d92a2a;
            }
        }
         & ul { 
            /* @media (--mobile) {
                padding-left: 0;
            } */
        }
	
        & .logos {
            & ul {
                /* padding: 0; */
            
                & li {
                    overflow: visible;
                    text-indent: -9999px;
                    float: left;
                    margin: 0 0 0 8px;
                    & a {
                        background: url('/img/logos/h11-go-ehb.png') no-repeat;
                        width: 100%;
                        height: 100%;
                        display: block;
                        &:hover {
                            background-position-y: -65px;
                        }
                    }
                }
                & .go {
                    width: 158px;
                    height: 65px;
                    & a {
                        background-position-x: -52px;
                    }
                }
                & .sg11 {
                    width: 52px;
                    height: 65px;
                }
                & .ehb {
                    width: 165px;
                    height: 65px;
                    & a {
                        background-position-x: -210px;
                    }
                }
            }
        }
        & .break {
            /* flex-basis: 100%;
            height: 0; */

            &.narrow {
                /* display: none; */
            }
        } 

    } 

    /* TODO: flex aanpassen zodat het zonder breaks werkt */
 /*   .footer {
        margin: 0;
        background-color: #14526b;
        position: relative;
        padding: 30px 20px 20px 150px;
        color: #FFFFFF;
        display: flex;
        flex-wrap: wrap;
        @media (--mobile) {
            padding-left: 45px;
        }
        &:before {
            content: "";
            position: absolute;
            top: -1px;
            bottom: 0;
            left: 0;
            width: 120px;
            background-color: #ffffff;
            transform: skew(-30deg);
            transform-origin: top;
            @media (--mobile) {
                width: 60px;
            }
        }
    
        & .menu {
            width: 180px;
            margin: 0px;
            position: relative;
            padding: 0 0 20px 40px;
            @media (--mobile) {
                width: 120px;
            }
            
            &:before {
                content: "";
                width: 20px;
                height: 2px;
                background-color: #d92a2a;
                left: 0;
                top: 10px;
                position: absolute;
            }
            &:after {
                content: "";
                height: 10px;
                width: 10px;
                border-radius: 50%;
                border: 2px solid #d92a2a;
                background-color: #ffffff;
                top: 4px;
                left: 20px;
                position: absolute;
            }
            &:hover:after {
                background-color: #d92a2a 
            }
            & h3 {
                margin: 0;
                color: #ffffff;
            }
            & a {
                text-decoration: none;
            }
        }
        & ul { 
            list-style-type: none; 
            padding: 10px 0px 10px 15px; 
            line-height: 1.4em; 
            margin: 0px; 
            @media (--mobile) {
                padding-left: 0;
            }
        }
	
        & a { 
            color: #FFF; 
        }
        & .logos {
            margin-left: auto;
            width: 400px;
            & ul {
                padding: 0;
            
                & li {
                    overflow: visible;
                    text-indent: -9999px;
                    float: left;
                    margin: 0 0 0 8px;
                    & a {
                        background: url('/img/logos/h11-go-ehb.png') no-repeat;
                        width: 100%;
                        height: 100%;
                        display: block;
                        &:hover {
                            background-position-y: -65px;
                        }
                    }
                }
                & .go {
                    width: 158px;
                    height: 65px;
                    & a {
                        background-position-x: -52px;
                    }
                }
                & .sg11 {
                    width: 52px;
                    height: 65px;
                }
                & .ehb {
                    width: 165px;
                    height: 65px;
                    & a {
                        background-position-x: -210px;
                    }
                }
            }
        }
        & .break {
            flex-basis: 100%;
            height: 0;

            &.narrow {
                display: none;
            }
        }

    } */
</style>